import { IconProps } from './IconProps';

export const SlimCheck = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0455 7.00098L9.04545 17.001L4.5 12.4555"
        stroke="#0882FF"
        stroke-width="1.81818"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
